import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { CustomerDataDTO } from '../../../common/types/dto/CustomerDataDTO';
import imgCheckLargeBMW from '../../assets/images/check-large-bmw.png';
import imgCheckLargeMINI from '../../assets/images/check-large-mini.png';
import cssForms from '../../assets/scss/Forms.scss';
import cssLayouts from '../../assets/scss/Layouts.scss';
import { RootState } from '../../base';
import { config } from '../../common/';
// import { useMatch } from '../../common/RouterHooks';
import TopNav from '../../main/components/TopNav';
import css from './SubscriptionContract.scss';

export interface CreateConfirmProps {
    planName: string;
    vehcode: number;
}

interface ReduxStateProps {
    customerInfo: CustomerDataDTO | undefined;
}

type CreateConfirmProperties =
    ReduxStateProps;

const CreateConfirm: React.FC<CreateConfirmProperties> = (Props) => {
    // const routeMatch = useMatch<CreateConfirmProps>();
    const { t } = useTranslation();

    // const vehicle = routeMatch.params.vehcode && Props.customerInfo && Props.customerInfo.vehicles && Props.customerInfo.vehicles.find((x) => x.vehcode === routeMatch.params.vehcode);
    // const prettyPlate = vehicle && vehicle.licensePlate && vehicle.licensePlate.length === 6 ? (vehicle.licensePlate.match(/.{1,2}/g) || []).join('-') : '';
    return (
        <React.Fragment>
            <TopNav
                items={[
                    {
                        to: `${config.BaseURL}`,
                        label: t('breadcrumbs.menu'),
                    },
                    {
                        to: `${config.BaseURL}/subscription/packs`,
                        label: t('breadcrumbs.subscription'),
                    },
                    {
                        to: '#',
                        label: t('subscriptions:confirm'),
                    },
                ]}
            />
            <section className={cssLayouts.header}>
                <h2>{t('subscriptions:confirmation.title')}</h2>
            </section>

            <div className={classNames([cssLayouts.container, cssLayouts.profile])}>
                <section className={cssLayouts.body}>
                    <div className={cssLayouts.wrapper}>
                        <section className={[cssForms.textSection, cssForms.rem, 'text-success'].join(' ')}>
                            <div className={cssForms.textSectionWrapper}>
                                <div className={css.confirmHeader}>
                                    <img src={config.BrandEnv === 'BMW' ? imgCheckLargeBMW : imgCheckLargeMINI} />
                                    <h1>{t('subscriptions:confirmation.title2')}</h1>
                                </div>
                                <p>
                                    <div dangerouslySetInnerHTML={{ __html: t('subscriptions:confirmation.text1')}} />
                                </p>
                                <div className={[cssForms.buttons, 'col-12', css.bottomBtn].join(' ')}>
                                    <Link to={`${config.BaseURL}/subscription/packs`} className={cssForms.width100} ><div className={[cssForms.bmwButton, cssForms.blue, cssForms.submit].join(' ')}>{t('signup:signupConfirm.closeBtn')}</div></Link>
                                </div>
                            </div>
                        </section>
                    </div>
                </section>
            </div>
        </React.Fragment>
    );
};

const mapStateToProps = (store: RootState) => ({
    customerInfo: store.customerState.customerData.data.customerData,
});

export default connect(mapStateToProps)(CreateConfirm);
